<template>
  <div>
    <div style="padding-left: 1.5rem"></div>
    <div id="configSection" class="columns-container">
      <div class="column">
        <div class="change-order-page__header-left">
          <h1>{{ i18n.t('/change-order/generic/your-order') }}</h1>
        </div>

        <div class="change-order-page__header-left section-header">
          <h3>{{ i18n.t('/change-order/sections/configuration') }}</h3>
        </div>

        <quote-list-block>
          <template #header>
            <div class="title">{{ i18n.t('/Configuration/BaseCar') }}</div>
            <div class="price price-incl">
              {{ i18n.t('/Common/InclBtw') }}
            </div>
          </template>
          <template #body>
            <li class="row">
              <div class="title">
                <div>{{ carDescription }}</div>
                <span style="display: inline-block; width: 5px" />
                <div>{{ changeOrder.CarConfiguration.EngineDescription }}</div>
                <div class="order-code">
                  <small>{{ changeOrder.CarConfiguration.OrderCode }}</small>
                </div>
              </div>
              <div class="price price-incl">
                {{ i18n.n(originalNetCatalogPriceIncl, 'currency') }}
              </div>
            </li>
          </template>
        </quote-list-block>
      </div>
      <div class="column">
        <div class="change-order-page__header-right">
          <h1>{{ i18n.t('/change-order/generic/modified-order') }}</h1>
        </div>

        <div class="change-order-page__header-right section-header">
          <h3>{{ i18n.t('/change-order/sections/configuration') }}</h3>
        </div>

        <div v-if="allowedToShowWarningBanner" class="unable-to-load-okapi-model-warning">
          <strong>{{ i18n.t('/Configuration/HasUnknownOkapiModel') }}</strong>
        </div>

        <div>
          <span v-if="configurationChanged" class="confirmation-message">
            <i class="fas fa-arrows-rotate"></i>&nbsp;
            <strong>
              {{ i18n.t('/change-order/generic/modified') }}
            </strong>
            &nbsp; {{ i18n.t('/change-order/generic/modified-confirmation') }}
          </span>
        </div>

        <quote-list-block>
          <template #header>
            <div class="title">{{ i18n.t('/Configuration/BaseCar') }}</div>
            <div class="price price-incl">
              {{ i18n.t('/Common/InclBtw') }}
            </div>
          </template>
          <template #body>
            <li class="row">
              <div class="title">
                <div>{{ carDescription }}</div>
                <span style="display: inline-block; width: 5px" />
                <div>{{ changeOrder.CarConfiguration.EngineDescription }}</div>
                <div class="order-code">
                  <small>{{ changeOrder.CarConfiguration.OrderCode }}</small>
                </div>
              </div>
              <div class="price price-incl">
                {{ i18n.n(changedNetCatalogPriceIncl, 'currency') }}
              </div>
            </li>
          </template>
        </quote-list-block>
      </div>
    </div>
  </div>
</template>

<script>
import QuoteListBlock from '@/components/generic/presentational/molecules/quoteListBlock/QuoteListBlock.vue'
import quoteOrderService from '@/services/quoteOrderService'
import { mapGetters } from 'vuex'
import { isEqual } from 'lodash'

export default {
  components: {
    QuoteListBlock,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      changeOrder: 'changeOrder/get',
    }),
    carDescription() {
      return (
        this.changeOrder.CarConfiguration.ModelName +
        ' ' +
        this.changeOrder.CarConfiguration.TrimlineName
      )
    },
    originalNetCatalogPriceIncl() {
      return this.changeOrder.CarConfiguration.OriginalPrice?.Incl
    },
    changedNetCatalogPriceIncl() {
      return this.changeOrder.CarConfiguration.ChangedPrice?.Incl
    },
    configurationChanged() {
      if (this.changeOrder.CarConfiguration.HasUnknownOkapiModel) {
        return
      }

      let changedShortIds = this.changeOrder.CarConfiguration.ChangedOptions.map(
        (option) => option.ShortId
      ).sort()

      let originalShortIds = this.changeOrder.CarConfiguration.OriginalOptions.map(
        (option) => option.ShortId
      ).sort()

      return !isEqual(originalShortIds, changedShortIds)
    },
    allowedToShowWarningBanner() {
      // Do not show the banner when OSM says no changes can be made to the car
      if (
        !this.changeOrder.Permissions.CanChangeColor.Allowed &&
        !this.changeOrder.Permissions.CanChangeInterior.Allowed &&
        !this.changeOrder.Permissions.CanChangeFactoryOption.Allowed
      ) {
        return false
      }

      return this.changeOrder.CarConfiguration.HasUnknownOkapiModel
    },
  },
  methods: {
    updateCalculateBpm(calculateBpm) {
      quoteOrderService.updateCalculateBpm(calculateBpm)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.row) {
  grid-template-columns: auto 8em 2em;
  grid-template-areas: 'title price-incl edit-dialog';
}

.columns-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.column {
  flex: 1;
  margin: 0 10px;
  padding: 0.5rem;
}

.title {
  overflow: auto;
}

.title div {
  display: inline-block;
}

.title .order-code {
  display: block;
  width: 100%;
}

.stockcarInfo {
  display: block;
  font-weight: 400;
  font-size: 0.875rem;
  padding: 20px 0 50px;
}

h3 {
  margin: 0;
}

.change-order {
  &-page__header-left {
    h1,
    h3 {
      color: $black;
      font-weight: 400;
    }
  }

  &-page__header-right {
    h1,
    h3 {
      color: $color-primary;
      font-weight: 400;
    }
  }
}

.section-header {
  border-bottom: 1px solid #a3b8c0;
  align-items: center;
  margin-bottom: 1rem;
}

.confirmation-message {
  margin-top: 5px;
  background-color: #ffdd9c;
  font-size: 18px;
  padding: 10px;
}

.unable-to-load-okapi-model-warning {
  background-color: $color-warning;
  color: $white;
  padding: 5px;
  box-shadow: $shadow-sm;
  border-radius: 1px;
}
</style>
